export const ICONS = {
  drag: "drag",
};

export const SLOTS = {
  actionsEnd: "actions-end",
  actionsStart: "actions-start",
};
